import { bootstrapApplication } from '@angular/platform-browser';

import { App } from '@gfe/app';
import { appConfig } from '@gfe/app.config';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
